import React from 'react'
import './AssignedRoles.css'
import './JobProcess.css';
import JobHeader from './JobHeader'
import SideBar from './SideBar'
import { Link } from 'react-router-dom'
import Autocompete from './Autocompete';
export default function AssignedRoles() {
  return (
    <> 
<JobHeader/>
<div class ="jobProcess">
    <SideBar/>
    
    <div class ="job-AssignedRoles">
    <h1>Assigned Roles</h1>
      <div class ="AssignedRoles-content">
        <h4>Roles</h4>
        <Autocompete/>
        <br/>
        <h4>Assigned To</h4> 
        <Autocompete/>
        <hr/>
        <button className='Add'>Add</button>
        
    </div></div> </div>
    <div className='next-bar'>
    <button className='back-btn'>Back</button>
    <button className='next-btn'>Next</button>
    
        </div>
        </>
  )
}
